<section class="main-wrap inner-views dashboard-wrap lens-module" [ngClass]="{ 'menu-open in': !toggleClass }">
  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <span class="sr-only">Toggle Dropdown</span>
        <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
      </button>
      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>
  <div class="container-wrap">
    <div class="heading-container sidebar-container" id="menu">
      <div class="row">
        <div class="col">
          <app-logo></app-logo>
          <div class="button-box">
            <button class="btn btn-sm-menu" type="button" (click)="toggleClass = !toggleClass">
              <img height="45" src="assets/images/icons/hamburger-menu-50x50.svg" width="45" alt="Menu Icon">
            </button>
          </div>
          <app-header></app-header>
        </div>
      </div>
    </div>
    <div class="content-container products-container single-product lens-module lens-perscription">
      <div class="row">
        <div class="col-md-6">
          <div class="lens-module-data">
            <app-product-data [tempCartEvents]="tempCartEventsSubject.asObservable()"></app-product-data>
          </div>
        </div>
        <div class="col-md-6">
          <div class="prod-col-in">
            <h2 class="prod-title">
              Lens Features
            </h2>
            <div class="progress" style="height: 7px;">
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active" role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active" role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar active" role="progressbar" style="width: 25%;"></div>
              <div aria-valuemax="100" aria-valuemin="0" aria-valuenow="25" class="progress-bar" role="progressbar" style="width: 25%;"></div>
            </div>
            <div class="clearfix"></div>
            <div class="col-md-12 module-non-prescription">
              @for (cdlo of companyDefaultLensOptions; track $index; let i = $index) {
                <h3>Required</h3>
                <p>Pre-selected options are covered and required on all orders placed with your benefit per your company’s policy.</p>
                <span class="border"></span>
                <div class="non-prescription-data">
                  <h3 [ngClass]="{'ignored-req-option': ignoredDefaultOptionIds.includes(cdlo.lensOptionId)}">
                    - {{cdlo.lensOptionName}} <span class="non-prescription-price">{{cdlo.price | currency}}</span>
                    @if (!ignoredDefaultOptionIds.includes(cdlo.lensOptionId)) {
                      <span class="check">
                        <img alt="Checkmark" height="30" src="assets/images/icons/check.svg" width="30" alt="Checkmark Icon"/>
                      </span>
                    }
                  </h3>
                  @if (ignoredDefaultOptionIds.includes(cdlo.lensOptionId)) {
                    <p class="text-orange">*Not applied based on lens resctrictions</p>
                  }
                </div>
              }
            </div>
            <div class="col-md-12 module-non-prescription additional-data">
              <h3>Additional</h3>
              <p>Additional features to add to your lenses.</p>
            </div>
            <ngx-ui-loader
              [loaderId]="'lensOptionsLoader'"
              [hasProgressBar]=false
              [bgsColor]="'#00000'">
            </ngx-ui-loader>
            @if (companyLensOptions.length > 0) {
              @if (coatingOptions.length > 0) {
                <div class="col-md-12 module-options" [ngClass]="{'disabled': hasDefaultCoating}">
                  <h3>Coatings</h3>
                  <i>*This category is not available based on the default options above.</i>
                  <a [routerLink]="['./coatings']" [queryParams]="queryParams" ><img height="15" src="assets/images/icons/angle-right-solid.svg" width="15" alt="Angle Right Icon"/></a>
                </div>
              }
              @if (tintOptions.length > 0) {
                <div class="col-md-12 module-options" [ngClass]="{'disabled': hasDefaultTint}">
                  <h3>Tints</h3>
                  <i>*This category is not available based on the default options above.</i>
                  <a [routerLink]="['./tints']" [queryParams]="queryParams"><img height="15" src="assets/images/icons/angle-right-solid.svg" width="15" alt="Angle Right Icon"/></a>
                </div>
              }
              @if (scratchOptions.length > 0) {
                <div class="col-md-12 module-options" [ngClass]="{'disabled': hasDefaultScratch}">
                  <h3>Scratch</h3>
                  <i>*This category is not available based on the default options above.</i>
                  <a [routerLink]="['./scratch']" [queryParams]="queryParams"><img height="15" src="assets/images/icons/angle-right-solid.svg" width="15" alt="Angle Right Icon"/></a>
                </div>
              }
            } @else {
              <div class="col-md-12 module-options">
                <h3>No lens options are provided through your company.</h3>
              </div>
            }
            <div class="col-md-12 module-nav next-step">
              <a class="btn product-btn gray-btn" [routerLink]="['/lens-selection']" type="button">Back</a>
              <button class="btn product-btn gray-btn" (click)="addToCart()" type="button">Add to Cart</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

